
/**
 * 환불 신청 상태
 */
export type RefundRequestResponseStatus = typeof RefundRequestResponseStatus[keyof typeof RefundRequestResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefundRequestResponseStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
